import './types';

/**
 * Note: the default config must have all supported keys of the logger configuration in order:
 * - to correctly map config to the logger settings and vice versa;
 * - to show a complete example what we can override by remote, local or runtime configs.
 */
export const DEFAULT_RUNTIME_CONFIG = {
    /** @type LogLevel */
    level: 'process' in globalThis ? 'warn' : 'info',
    transports: {
        // use null instead of configuration object (e.g. idb: null) to prevent any transport from being created
        console: {
            /** @type LogLevel */
            level: null,
            /**
             * Each prefix has its own color in the browser console for better readability. The color set depends on devtools theme:
             * dark - light colors of prefixes will be used to achieve high contrast with dark background
             * light -  defines dark prefix colors
             * system - default, depends on system color scheme (not devtools) and picks one of the options above
             * @type DevToolsTheme
             */
            devToolsTheme: 'system',
        },
        idb: {
            /** @type LogLevel */
            level: null,
            /** maximum time (in milliseconds) of storing logs in idb */
            entryLifespan: 7 * 24 * 3600 * 1000,
            /** Limit the number of messages per store - IndexedDBTransport has separate store for each level. */
            entriesLimitPerStorage: 20000,
        },
        desktopSdk: {
            /** @type LogLevel */
            level: null,
        },
        externalApi: {
            /** @type LogLevel */
            level: null,
        },
        pii: process.env.NODE_ENV === 'development' ? { level: null } : null,
    },
    prefixes: '',
};
